<template>
  <span :class="monthlyCostStyle">
    {{ amount | prettyMoney }}
    <span v-if="monthlyCostIcon" :class="monthlyCostIcon"></span>
</span>
</template>

<script>
export default {
  name: "MoneySaved",
  
  props: {
    baselineAmount: {
      type: Number,
      default: null
    },
    amount: Number,
    iconSize: {
      type: String,
      default: "fa-xxs"
    }
  },
  
  computed: {
    monthlyCostIcon() {
      return this.monthlyDifference === 0 ? null :
          this.monthlyDifference < 0 ? "fa " + this.iconSize + " fa-caret-up" : "fa " + this.iconSize + " fa-caret-down";
    },
    monthlyCostStyle() {
      return this.monthlyDifference === 0 ? null :
          this.monthlyDifference < 0 ? "text-danger" : "text-success";
    },

    monthlyDifference() {
      return this.baselineAmount == null ? this.amount : this.baselineAmount - this.amount;
    }
  }
}
</script>

<style scoped>

</style>